function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  id: "facebook-icon-b",
  cx: 16,
  cy: 16,
  r: 16
}), /*#__PURE__*/React.createElement("path", {
  fill: "#474747",
  d: "M17.1328125,13.15625 L19.7142857,13.15625 L19.4129464,16.0089286 L17.1328125,16.0089286 L17.1328125,24.2857143 L13.7075893,24.2857143 L13.7075893,16.0089286 L12,16.0089286 L12,13.15625 L13.7075893,13.15625 L13.7075893,11.4386161 C13.7075893,10.21986 13.9955328,9.29743617 14.5714286,8.67131696 C15.1473243,8.04519776 16.0948595,7.73214286 17.4140625,7.73214286 L19.6941964,7.73214286 L19.6941964,10.5848214 L18.2678571,10.5848214 C18.0066951,10.5848214 17.7974338,10.6065846 17.640067,10.6501116 C17.4827001,10.6936386 17.368862,10.7723209 17.2985491,10.8861607 C17.2282363,11.0000006 17.1830358,11.1155128 17.1629464,11.2327009 C17.142857,11.349889 17.1328125,11.5156239 17.1328125,11.7299107 L17.1328125,13.15625 Z"
}));

function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.ac4f4895.svg";
export { ForwardRef as ReactComponent };